import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m5.876 14.295-.766 2.859-2.8.059A10.95 10.95 0 0 1 1 12c0-1.824.444-3.544 1.23-5.059l2.492.457 1.092 2.477A6.538 6.538 0 0 0 5.46 12c0 .807.146 1.581.415 2.295Z",
      fill: "#FBBB00"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22.808 9.945c.126.665.192 1.353.192 2.055a10.997 10.997 0 0 1-4.113 8.578h-.001l-3.139-.16-.444-2.774a6.555 6.555 0 0 0 2.82-3.347h-5.881V9.945H22.808Z",
      fill: "#518EF8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.886 20.577v.001A10.954 10.954 0 0 1 12 23c-4.189 0-7.831-2.342-9.689-5.787l3.565-2.918a6.54 6.54 0 0 0 9.427 3.35l3.583 2.932Z",
      fill: "#28B446"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.021 3.532 15.458 6.45a6.542 6.542 0 0 0-9.644 3.425L2.231 6.94H2.23A10.998 10.998 0 0 1 12 1c2.669 0 5.116.95 7.021 2.532Z",
      fill: "#F14336"
    }, null, -1)
  ]))]))
}
export default { render };